import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import { LinearProgress } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { getCongress, getUserMe } from "../ducks/actions";
import { useCongress, useInterval, useUserMe } from "../hooks";

const DataLoader = ({ children }) => {
  const dispatch = useDispatch();
  const sendDataToGTM = useGTMDispatch();
  const location = useLocation();

  const [polling, setPolling] = useState(false);

  useEffect(() => {
    dispatch(getCongress());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getUserMe());
  }, [dispatch]);

  useInterval(async () => {
    setPolling(true);
    await dispatch(getUserMe());
    setPolling(false);
  }, 180000);

  const { congress } = useCongress();
  const { user, userLoading } = useUserMe();

  useEffect(() => {
    sendDataToGTM({ event: "pageview", value: location, userId: user?.id || null });
  }, [location, sendDataToGTM, user?.id]);

  if (congress.loaded && (!userLoading || polling)) {
    return children;
  }

  return <LinearProgress />;
};

export default DataLoader;
